import videojs from 'video.js';
import 'video.js/dist/video-js.css';

function initBlockVideos() {
    const players = [];

   document.querySelectorAll('.block-video .video-js').forEach(function (el) {
    const player = videojs(el, {
        bigPlayButton: false,
        inactivityTimeout: 0,
        controlBar: {
            playToggle: false,
            volumePanel: false,
            currentTimeDisplay: false,
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            playbackRateMenuButton: false,
            chaptersButton: false,
            descriptionsButton: false,
            subsCapsButton: false,
            audioTrackButton: false,
            pictureInPictureToggle: false,
            fullscreenToggle: false,
        }
    });
    players.push(player);

    const id = player.id(); 

    const controls = document.querySelector(
        '.block-video-controls[data-player="' + id + '"]'
    );

    // Pausar los demás al reproducir este
    player.on('play', () => {
        players.forEach((other) => {
            if (other !== player && !other.paused()) {
                other.pause();
            }
        });
    });

    if (!controls) return;

    const playBtn = controls.querySelector('[data-action="play"]');
    const muteBtn = controls.querySelector('[data-action="mute"]');

    playBtn?.addEventListener('click', () => {
        player.paused() ? player.play() : player.pause();
    });
    player.on('play',  () => { if (playBtn) playBtn.textContent = 'pause'; });
    player.on('pause', () => { if (playBtn) playBtn.textContent = 'play'; });

    controls.querySelector('[data-action="fullscreen"]')
        ?.addEventListener('click', () => {
            player.isFullscreen() ? player.exitFullscreen() : player.requestFullscreen();
        });

    muteBtn?.addEventListener('click', () => {
        player.muted(!player.muted());
    });
    player.on('volumechange', () => {
        if (muteBtn) muteBtn.textContent = player.muted() ? 'no audio' : 'audio';
    });
});
}

// Corre aunque DOMContentLoaded ya haya pasado
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlockVideos);
} else {
    initBlockVideos();
}